import menu from '../store/modules/menu';
import { Toast } from 'vant';
import Vue from 'vue';
import axios from 'axios';

Vue.use(Toast);

export default {
    // 千位符分割处理
    fillNumberWithComma (num) {
      let str = String(num);
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    // 元转换为万元、亿元
    numberFormat (value, unit) {
        var param = {};
        var k = 10000;
            var sizes = ['', '万元', '亿'];
            var i;
        if (value < k) {
            param.value = Number(value).toFixed(2);
            param.unit = '元';
        } else {
            i = Math.floor(Math.log(value) / Math.log(k));
            param.value = (value / Math.pow(k, i)).toFixed(2);
            param.unit = sizes[i];
        }
        let num = this.fillNumberWithComma(param.value);
        // return `${num}<span>param.unit</span>`
        return {
            num: num,
            unit: param.unit
        }
    },
    // 秒转为时分秒
    formatSeconds (value) {
        let result = parseInt(value)
        let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
        let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
        let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

        let res = '';
        if (h !== '00') res += `${h}时`;
        if (m !== '00') res += `${m}分`;
        res += `${s}秒`;
        return res;
    },
    // 电话转换为隐私状态，如:14578457845变为1457 **** 7845
    changePhone (phone) {
        return phone.substr(0, 4) + ' **** ' + phone.substr(7)
    },
    setLocal (name, val) {
        localStorage.setItem(name, val);
    },
    getLocal (name) {
        return localStorage.getItem(name);
    },
    setJsonLocal (name, json) {
        localStorage.setItem(name, JSON.stringify(json));
    },
    getJsonLocal (name) {
        if (!JSON.parse(localStorage.getItem(name))) {
            return '';
        } else {
            return JSON.parse(localStorage.getItem(name));
        }
    },
    removeJsonLocal (name) {
        return localStorage.removeItem(name);
    },
    getUserId () {
        const localAuth = this.getJsonLocal('appraiseNewLocalauthority');
        return localAuth.userId;
    },
    /***
     * 参数值: ASSESS_STATICS:数据可视化和统计报表
     *         ASSESS_SCORE：考核项目
     *        ASSESS_NOTICE： 系统消息和通知公告
     */
    getAuthorityList (witchAuth) { // 取三个模块中的 某个模块
        const localAuth = this.getJsonLocal('appraiseNewLocalauthority');
        if (localAuth) {
            const authoritislist = localAuth.roleInfo.authorities;
            for (let i = 0; i < authoritislist.length; i++) {
                if (witchAuth === authoritislist[i].menuModuleEnum.code) {
                    return authoritislist[i].authorities
                }
            }
        }
        //    console.log('----本地权限', this.getJsonLocal('appraiseNewLocalauthority').roleInfo.authorities);
    },
    getChileAuthList (chileAuthlist, menuValue) { // 取模块中的 父级权限 和 children集合权限
        // console.log('------父级:', menuValue);
        if (chileAuthlist && chileAuthlist.length > 0) {
            if (menuValue) {
                // 有menuValue 取里层子权限

                for (let i = 0; i < chileAuthlist.length; i++) {
                    // console.log('-----权限判断：', chileAuthlist[i]);
                    if (menuValue === chileAuthlist[i].authorityCode.value) {
                        // console.log('-----这里呢:', chileAuthlist[i]);
                        return chileAuthlist[i];
                    }
                }
            } else {
                // 没有menuValue 取 外层所有大权限，过滤一遍 不需要显示的权限列表
                let temChildAuthList = [];
                for (let i = 0; i < chileAuthlist.length; i++) {
                    if (chileAuthlist[i].assessType) {
                        temChildAuthList.push(chileAuthlist[i]);
                    }
                }
                // 要在首页显示的列表
                return temChildAuthList;
            }
        } else {
            return false;
        }
    },
    getChildAuthListToChild (children, childMenuValue) { // 取最小项的 child 权限
        // console.log('-----children:', children);
        if (children) {
            const childList = children.children;
            // console.log('-----外层:', childList);
            if (childList && childList.length > 0) {
                for (let i = 0; i < childList.length; i++) {
                    //    console.log('-----数组集合:', childList);
                    if (childList[i].authorityCode.value === childMenuValue) {
                        return childList[i].operationType; // 数组 包对象
                        /**
                         * 例子
                         * operationType[ { name: '新增', path: null, value: 'OPERATION01'}]
                         *
                         */
                    }
                }
            }
        }
    },
    fixYear (str) {
        return str ? str.substring(0, 4) : str;
    },
    fixquarter (str) {
        if (str === '第一季度') {
            return 1;
        } else if (str === '第二季度') {
            return 2;
        } else if (str === '第三季度') {
            return 3;
        } else {
            return 4;
        }
    },
    fixAddress (str) {
        if (str === '一类地区') {
            return 1;
        } else {
            return 2;
        }
    },
    fixBtoKBorMB (fileSize) {
        if (fileSize < 1024) {
            return fileSize + 'B';
        } else if (fileSize < (1024 * 1024)) {
            let temp = fileSize / 1024;
            temp = temp.toFixed(2);
            return temp + 'KB';
        } else if (fileSize < (1024 * 1024 * 1024)) {
            let temp = fileSize / (1024 * 1024);
            temp = temp.toFixed(2);
            return temp + 'MB';
        } else {
            let temp = fileSize / (1024 * 1024 * 1024);
            temp = temp.toFixed(2);
            return temp + 'GB';
        }
    },
    getProcess () {
        let key = '';
        console.log('----环境:', process.env);
        if (process.env.NODE_ENV == 'development') {
            key = 'test';
        } else if (process.env.NODE_ENV == 'test') {
            key = 'test';
        } else {
            key = 'prod';
        }
        return key;
    },
    getFileType (type) {
        console.log('-----文件类型：', type);
        if (type === 'application/pdf' || type === 'pdf') {
            return 'pdf'
        } else if (type === 'application/doc' || type === 'application/msword' || type === 'doc' || type === 'docx' || type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || type === '"application/vnd.openxmlformats-officedocument.wordprocessingml.document"') {
            return 'doc'
        } else if (type === 'image/jpeg' || type === 'jpeg' || type === 'jpg') {
            return 'jpg'
        } else if (type === 'image/png') {
            return 'png'
        } else if (type === 'xls' || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || type === 'xlsx') {
            return 'exl'
        } else {
            return type;
        }
    },
    getUrlParam (param) {
        //  截取字符串
        var re = new RegExp('(\\?|&)' + param + '=([^&|^#]+)(&|#|$)', 'i');
        var m = window.location.href.match(re);
        if (m) {
            return decodeURIComponent(m[2]);
        } else {
            return '';
        }
    },
    getWeekStartEnd (moment, date) {
        //  获取本周的，周一和周天
        let oneDayTime = 24 * 60 * 60 * 1000;
        let now = new Date(date);
        let nowTime = now.getTime();
        let day = now.getDay();
        if (day === 0) {
            let end = moment(new Date(date)).format('YYYY-MM-DD');
            let start = moment(new Date(date) - 6 * oneDayTime).format('YYYY-MM-DD');
            return { start, end };
        } else {
            let oneDayTime = 24 * 60 * 60 * 1000;
            let MondayTime = nowTime - (day - 1) * oneDayTime;
            let SundayTime = nowTime + (7 - day) * oneDayTime;
            let start = moment(new Date(MondayTime)).format('YYYY-MM-DD');
            let end = moment(new Date(SundayTime)).format('YYYY-MM-DD');
            return { start, end };
        }
    },
    // 时间戳转为年月日时分秒
    getStampInDate (time, Delimiter = '-') {
        let date = new Date(time * 1); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + Delimiter;
        let M =
            (date.getMonth() + 1 < 10
                ? '0' + (date.getMonth() + 1)
                : date.getMonth() + 1) + Delimiter;
        let D =
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        let h =
            (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        let m =
            (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
            ':';
        let s =
            date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        let strDate = Y + M + D + h + m + s;
        return strDate;
    },

    // 时间戳转换为月日时分
    getStampInDate2 (time, Delimiter = '/') {
        let date = new Date(time * 1); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        // let Y = date.getFullYear() + Delimiter;
        let M =
            (date.getMonth() + 1 < 10
                ? '0' + (date.getMonth() + 1)
                : date.getMonth() + 1) + Delimiter;
        let D =
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        let h =
            (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        let m =
            (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
        let s =
            date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        // let strDate = Y + M + D + h + m + s;
        let strDate = M + D + h + m
        return strDate;
    },
    // 时间戳转换为年-月-日 时:分
    getStampInDate3 (time) {
        let date = new Date(time * 1); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M =
            (date.getMonth() + 1 < 10
                ? '0' + (date.getMonth() + 1)
                : date.getMonth() + 1) + '-';
        let D =
            (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        let h =
            (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        let m =
            (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
        let s =
            date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        let strDate = Y + M + D + h + m;
        return strDate;
    },
    // 时间戳转换为时分秒
    getStampInDate4 (mss) {
        try {
            var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
            minutes = minutes.toFixed(0) < 10 ? `0${minutes.toFixed(0)}` : minutes.toFixed(0)
            var seconds = parseInt(mss % (1000 * 60)) / 1000;
            seconds = seconds.toFixed(0) < 10 ? `0${seconds.toFixed(0)}` : seconds.toFixed(0)
            return hours + ':' + minutes + ':' + seconds
        } catch (err) {
            alert(err)
        }
    },
    // 时间戳转为年月
    getStampInDateYera (time) {
        let date = new Date(time * 1); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let strDate = Y + M;
        return strDate;
    },
    // 时间戳转为年月日
    getStampInDateDay (time) {
        let date = new Date(time * 1); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        let strDate = Y + M + D;
        return strDate;
    },

    /**
     *      获取近30天日期
     */
    startdateDay () {
        // 获取三十天前日期

        var myDate = new Date();
        var nowY = myDate.getFullYear();
        var nowM = myDate.getMonth() + 1;
        var nowD = myDate.getDate();
        var enddate = nowY + '-' + (nowM < 10 ? '0' + nowM : nowM) + '-' + (nowD < 10 ? '0' + nowD : nowD); // 当前日期

        let obj = {
            startdate,
            enddate
        }
        console.log(obj, 'obj----')
        return obj;
    },
    /**
     *      下载文件
     */
    download (value) {
        Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true
        });
        axios({
            method: 'get',
            headers: {
                'Content-Type': 'application/json'
            },
            url: value.link,
            responseType: 'blob'
        }).then((res) => {
            // console.log(res);
            if (!res.data) {
                return;
            }
            var blob = new Blob([res.data]);
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement('a');
            aLink.style.display = 'none';
            aLink.href = url;
            aLink.setAttribute('download', value.filename);
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
            Toast.success('下载成功');
        }).catch(res => {
            console.log(res)
            Toast.fail('下载失败');
        });
    },

    /**
     *      下载文件
     */
    download (value) {
        Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true
        });
        axios({
            method: 'get',
            headers: {
                'Content-Type': 'application/json'
            },
            url: value.link,
            responseType: 'blob'
        }).then((res) => {
            // console.log(res);
            if (!res.data) {
                return;
            }
            var blob = new Blob([res.data]);
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement('a');
            aLink.style.display = 'none';
            aLink.href = url;
            aLink.setAttribute('download', value.filename);
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
            Toast.success('下载成功');
        }).catch(res => {
            console.log(res)
            Toast.fail('下载失败');
        });
    },
    // 获取字符串所有中括号的内容
    getBracketSt (value) {
        // let result = ''
        let regex = /\【(.+?)\】/g;
        let options = value.match(regex)
        return options
    },
    // 字符串脱敏，只显示第一位
    desensitization (val) {
        val = val.replace(/\s+/g, '');
        let firstStr = val.substr(0, 1)
        for (let i = 1; i < val.length; i++) {
            firstStr += '*'
        }
        return firstStr
    }
};
/**
 * @description 深拷贝数据方法
 * @function deepClone
 * @param obj 需要深拷贝的数据
 * @return newObj 深拷贝出来的数据
 */
export function deepClone (obj) {
    if (obj === null) return null; // 如果数据为null
    if (obj instanceof RegExp) return new RegExp(obj); // 如果数据为正则表达式
    if (obj instanceof Date) return new Date(obj); // 如果数据为日期对象
    if (typeof obj === 'function') return new function (obj) { }(); // 如果为函数
    if (typeof obj !== 'object') return obj; // 非复杂类型直接返回，同时也是结束递归的条件

    // [].__proto__.constructor = Array()
    // {}.__proto__.constructor = object()
    let newObj = new obj.__proto__.constructor();
    for (let key in obj) {
        newObj[key] = deepClone(obj[key])
    }
    return newObj;
}
